import type { QueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

const inflight = new Map<string, Promise<void>>();

export function markSectionItemComplete(
  sectionItemId: string,
  options?: { courseId?: string; queryClient?: QueryClient },
): Promise<void> {
  const existing = inflight.get(sectionItemId);
  if (existing) return existing;

  const promise = api(`/progress/items/${sectionItemId}/complete`, { method: 'POST' })
    .then(() => {
      if (options?.courseId && options.queryClient) {
        void options.queryClient.invalidateQueries({
          queryKey: ['student', 'courses', options.courseId],
        });
      }
    })
    .finally(() => {
      inflight.delete(sectionItemId);
    });

  inflight.set(sectionItemId, promise);
  return promise;
}
